export const MAX_MATCHWEEK = 38;

/**
 * Which matchweek a page should open on.
 *
 * The API's `current_matchweek` is the highest matchweek with at least one
 * kicked-off fixture, which is right while a round is in progress but sticks
 * there once it finishes — the Saturday after MW1 completes, "current" is
 * still MW1 even though everyone is now picking MW2.
 *
 * So when the current matchweek is fully played out, move on to the next one.
 * Shared by the pick page and the pool home so the two cannot disagree about
 * which matchweek is being shown.
 */
export function defaultMatchweek(meta) {
  if (!meta) return 1;

  const current = meta.current_matchweek;
  const next = meta.next_matchweek;
  const lastCompleted = meta.last_completed_matchweek;

  if (
    typeof current === "number" &&
    typeof lastCompleted === "number" &&
    lastCompleted >= current &&
    typeof next === "number"
  ) {
    return Math.min(next, MAX_MATCHWEEK);
  }

  if (typeof current === "number") {
    return Math.min(Math.max(current, 1), MAX_MATCHWEEK);
  }

  return 1;
}
